export const messages = {
  'wr-dashboard.search.input.hint': 'Search',
  'wr-dashboard.search.label.breadcrumb': 'Search results',
  'wr-dashboard.search.message.empty': 'No items match your search',
  'wr-dashboard.side-bar.selected.title:plural': '{count} item selected | {count} items selected',
  'wr-dashboard.side-bar.backup-type.disk': 'Disk',
  'wr-dashboard.side-bar.backup-type.file': 'File',
  'wr-dashboard.side-bar.backup-type.notarized': 'Notarized files and folders',
  'wr-dashboard.side-bar.backup-type.exchange': 'Application - Microsoft Exchange',
  'wr-dashboard.side-bar.backup-type.sql': 'Application - Microsoft SQL',
  'wr-dashboard.side-bar.backup-type.sys-state': 'Application - System state',
  'wr-dashboard.side-bar.backup-type.application': 'Application',
  'wr-dashboard.backups-table.column.name': 'Name',
  'wr-dashboard.backups-table.column.size': 'Size',
  'wr-dashboard.backups-table.column.version': 'Last version',
  'wr-dashboard.backups-table.action.delete': 'Delete',
  'wr-dashboard.backups-table.message.no-backups': 'There are no backups yet in Cloud',
  'wr-dashboard.backups-sidebar.label.size': 'Size',
  'wr-dashboard.backups-sidebar.label.type': 'Type',
  'wr-dashboard.backups-sidebar.label.version': 'Last version',
  'wr-dashboard.backups-sidebar.label.created': 'Created',
  'wr-dashboard.backups-sidebar.label.machine': 'Machine',
  'wr-dashboard.backups-sidebar.label.owner': 'Owner',
  'wr-dashboard.content-table.column.name': 'Name',
  'wr-dashboard.content-table.column.versions': 'Versions',
  'wr-dashboard.content-table.column.volumes': 'Volumes',
  'wr-dashboard.content-table.column.path': 'Path',
  'wr-dashboard.content-table.column.size': 'Size',
  'wr-dashboard.content-table.column.version': 'Last version',
  'wr-dashboard.content-table.action.notary-verify': 'Verify',
  'wr-dashboard.content-table.action.notary-get-crt': 'Get certificate',
  'wr-dashboard.content-table.action.asign': 'Send for signature',
  'wr-dashboard.content-table.action.versions': 'Versions',
  'wr-dashboard.content-table.action.restore': 'Download',
  'wr-dashboard.content-table.label.size': 'Size',
  'wr-dashboard.content-table.label.created': 'Created',
  'wr-dashboard.content-table.label.modified': 'Modified',
  'wr-dashboard.content-table.message.empty-folder': 'This folder is empty',
  'wr-dashboard.password-dialog-box.title.backup': 'Encrypted backup',
  'wr-dashboard.password-dialog-box.title.archive': 'Encrypted archive',
  'wr-dashboard.password-dialog-box.message.backup': 'Please specify the password to access the backup {displayName}',
  'wr-dashboard.password-dialog-box.message.archive': 'Please specify the password to access the archive {displayName}',
  'wr-dashboard.password-dialog-box.hint.password': 'Password',
  'wr-dashboard.password-dialog-box.message.invalid-password': 'The password is incorrect',
  'wr-dashboard.form.button.open': 'Open',
  'wr-dashboard.form.button.close': 'Close',
  'wr-dashboard.form.button.cancel': 'Cancel',
  'wr-dashboard.form.button.continue': 'Continue',
  'wr-dashboard.form.button.proceed': 'Proceed',
  'wr-dashboard.form.button.delete': 'Delete',
  'wr-dashboard.form.button.done': 'Done',
  'wr-dashboard.form.button.retry': 'Retry',
  'wr-dashboard.notary.verify.view.status.downloading': 'Downloading...',
  'wr-dashboard.notary.verify.view.status.validating': 'Validating...',
  'wr-dashboard.notary.verify.view.status.pending': 'Pending certificate...',
  'wr-dashboard.notary.verify.view.status.fail': 'Certificate mismatch...',
  'wr-dashboard.notary.verify.view.button.get-crt': 'Get certificate',
  'wr-dashboard.notary.verify.view.file-info.name': 'NAME',
  'wr-dashboard.notary.verify.view.file-info.signed-by': 'SIGNED BY',
  'wr-dashboard.notary.verify.view.file-info.date-backed-up': 'DATE BACKED UP',
  'wr-dashboard.notary.verify.view.file-info.date-notarized': 'DATE NOTARIZED',
  'wr-dashboard.notary.verify.view.button.cancel': 'Cancel',
  'wr-dashboard.notary.verify.view.button.done': 'Done',
  'wr-dashboard.notary.warning.unsupported.browser.version': 'Unsupported browser version',
  'wr-dashboard.versions-dialog-box.title': 'Versions of {fileName}',
  'wr-dashboard.asign-dialog-box.title': 'Send for signature',
  'wr-dashboard.asign-dialog-box.message': 'The file version is shared but no one can view the file without the link to it. Proceed to ASign to add signatories and share the link.',
  'wr-dashboard.asign-dialog-box.button.show-signed-file-details': 'Show file Details',
  'wr-dashboard.page-not-found.title': 'Page not found',
  'wr-dashboard.page-not-found.message.main': 'The page you were looking for was not found.',
  'wr-dashboard.page-not-found.message.description': 'The link may be outdated, or you may have typed the address incorrectly.',
  'wr-dashboard.page-not-found.message.error': 'Error code: 404',
  'wr-dashboard.server-error.title': 'Server is not available',
  'wr-dashboard.server-error.message': 'The server is not available at the moment. Please try again later.',
  'wr-dashboard.server-error.message.error': 'Error code: 500',
  'wr-dashboard.account-menu.action.sign-out': 'Sign out',
  'wr-dashboard.breadcrumb.item.machines': 'Machines',
  'wr-dashboard.breadcrumb.item.failed-backups': 'Failed backups',
  'wr-dashboard.machines-table.column.name': 'Name',
  'wr-dashboard.machines-table.column.size': 'Size',
  'wr-dashboard.machines-table.message.no-machines': 'There are no machines yet in Cloud',
  'wr-dashboard.incomplete-backups.message.status:plural': 'You have {count} failed or incomplete backup occupying {size} of storage | You have {count} failed or incomplete backups occupying {size} of storage',
  'wr-dashboard.incomplete-backups.button.view': 'View backups',
  'wr-dashboard.incomplete-backups.button.delete': 'Delete backups',
  'wr-dashboard.machines-table.message.space-used:plural': 'Total backup usage {size}',
  'wr-dashboard.delete-archive-dialog-box.title': 'Delete archives',
  'wr-dashboard.delete-incomplete-archive-dialog-box.title': 'Delete incomplete archives',
  'wr-dashboard.delete-all-incomplete-archives-dialog-box.title': 'Delete all incomplete archives',
  'wr-dashboard.delete-archive.message': 'Аre you sure that you want to permanently delete the selected archives from all locations? All the data will be deleted and cannot be restored.',
  'wr-dashboard.delete-archive.deletion-warning-message': 'Making any changes in this web restore console may not be visually reflected in the protection console\'s respective workload if that workload is not online, nor any agent is online to process the changes',
  'wr-dashboard.delete-archive.locked-error-message': 'The archive has been locked to ensure data consistency. Please terminate all operations with the archive (e.g., browse, restore, back up) and try again.',
  'wr-dashboard.certificate-pending-dialog-box.title': 'Certificate is pending',
  'wr-dashboard.certificate-pending-dialog-box.message': 'Please try again in a few minutes.',
  'wr-dashboard.form.button.ok': 'Ok'
};
